import { useEffect } from "react";
import { useTour } from "@reactour/tour";
import { find, map, get } from "lodash";
import { parseStepsToComponents } from "src/components/tour/renderer/index";
import { canShowTour } from "src/utils/productTours";
import { useProductToursFetch } from "src/query/productTour";
import { ProductTour } from "./tour.type";

export const TourWatcher = () => {
  const { setIsOpen, setSteps, setMeta } = useTour();
  const { data: productTours } = useProductToursFetch();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      // find clicked element or its parent with data-testid
      const el = target.closest("[data-testid]") as HTMLElement | null;
      if (!el) return;

      const tourId = el.dataset["testid"];
      if (!tourId) return;

      const shouldShowTour = canShowTour(tourId, productTours);
      if (!shouldShowTour) return;

      startTour(tourId);
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [productTours]);

  const startTour = (tourId: string) => {
    if (!productTours?.length) return;

    const tour = find(productTours, (t: ProductTour) =>
      t.moduleIds?.includes(tourId)
    );

    if (!tour) return;

    const steps = parseStepsToComponents(get(tour, "steps", []));
    setSteps?.(steps);
    setIsOpen(true);
    setMeta?.(tourId);
  };

  return null;
};